/*
Sohel  12/19/2022 3075154998 Added data manager record screen Stepper
Sohel  12/29/2022 3075154998 Added Import Manager Record Screen
Sohel 01/31/2023 3075154998 label changes
Sohel 01/08/2023 2701335619 Implemented Usage Functionality
Akhila 06/08/2023 2701335619 title label placeholder name change
Akhila 06/12/2023 2701335619 added role access
Phanee 08/03/2023 2701335619 Fixed dashboard data disable issue
*/
import React, {useState, useContext} from 'react';
import LandingPage from '../../../../Pages/LandingPage';
import {ThemeContext} from '../../../../themes/ThemeProvider';
import AddDataManagerRecord from './AddDataManagerRecord';
import DataManagerRecordUsage from './DataManagerRecordUsage';
import SearchDataManagerRecord from './SearchDataManagerRecord';
import {useSelector} from 'react-redux';
import {EXPORT_DATA, IMPORT_DATA} from '../../../../constants/ReusableRoleAccess';

function DataManagerRecord() {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [value, setValue] = useState(0);
  const exportTemplateRecord =
    location.pathname === '/frameworks/export-template-record' ? true : false;
  const [dataManagerRecordData, setDataManagerRecordData] = useState({});
  const [editExisting, setEditExisting] = useState(false);
  const {roleData} = useSelector(({role}) => role);
  const dmTempRecordAccess = exportTemplateRecord ?
    roleData?.window?.[EXPORT_DATA]?.['ETMPR'] :
    roleData?.window?.[IMPORT_DATA]?.['ITMPR'];
  const exportRecordGroupAccess = roleData?.window?.[EXPORT_DATA]?.['ERG'];
  const importRecordGroupAccess = roleData?.window?.[IMPORT_DATA]?.['IRG'];

  const tabLabels = ['Import Template Records'];
  return (
    <>
      <LandingPage
        title={'Data Management'}
        showTabs={true}
        tabValue={0}
        handleTabChange={()=>{}}
        allAntTabs={tabLabels}
      >
        <div className="global-field-dash-board">
          <div className={` ${classes.cardStyleWhite}`}>
            <div className={classes.root}>
              <div className={classes.subContent}>
                {value === 0 && (
                  <SearchDataManagerRecord
                    setValue={setValue}
                    setDataManagerRecordData={setDataManagerRecordData}
                    type="Import"
                    dmTempRecordAccess={dmTempRecordAccess}
                    setEditExisting={setEditExisting}
                  />
                )}
                {value === 1 && (
                  <AddDataManagerRecord
                    setValue={setValue}
                    editExisting={editExisting}
                    dmTempRecordAccess={dmTempRecordAccess}
                    exportRecordGroupAccess={exportRecordGroupAccess}
                    importRecordGroupAccess={importRecordGroupAccess}
                  />
                )}
                {value === 2 && (
                  <DataManagerRecordUsage
                    setValue={setValue}
                    dataManagerRecordData={dataManagerRecordData}
                    exportManagerRecord={false}
                    editExisting={editExisting}
                    dmTempRecordAccess={dmTempRecordAccess}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </LandingPage>
    </>
  );
}

export default DataManagerRecord;
